import React from "react";
import { MDBBtn } from "mdbreact";

function PanelFirmaDigital({ condicionesLaborales, calendarioActivo, descargardocumento, onVerDocumento, onFirmarDocumento, informacionregistro, yaFirmado, usuarioDatoRef, onCondicionChange, pdfPreviewUrl, pdfFirmadoUrl, firmando, errorFirma }) {
  var modalState = React.useState(false);
  var modalOpen = modalState[0];
  var setModalOpen = modalState[1];

  var modalUrlState = React.useState(null);
  var modalUrl = modalUrlState[0];
  var setModalUrl = modalUrlState[1];

  var esFirmadoState = React.useState(false);
  var modalEsFirmado = esFirmadoState[0];
  var setModalEsFirmado = esFirmadoState[1];

  var haVistoState = React.useState(false);
  var haVisto = haVistoState[0];
  var setHaVisto = haVistoState[1];

  var exitoState = React.useState(false);
  var mostrarExito = exitoState[0];
  var setMostrarExito = exitoState[1];

  // Ref para saber si el modal estaba abierto cuando llegue pdfFirmadoUrl
  var modalOpenRef = React.useRef(false);

  var hasRegistros = informacionregistro && informacionregistro.length > 0;

  // Mantener ref sincronizado con modalOpen
  React.useEffect(function() {
    modalOpenRef.current = modalOpen;
  }, [modalOpen]);

  // Bloquear scroll mientras el modal está abierto
  React.useEffect(function() {
    if (modalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return function() { document.body.style.overflow = ''; };
  }, [modalOpen]);

  // Abrir modal cuando el PDF original esté listo (Ver Documento)
  React.useEffect(function() {
    if (pdfPreviewUrl) {
      setModalUrl(pdfPreviewUrl);
      setModalEsFirmado(false);
      setModalOpen(true);
      setHaVisto(true);
    }
  }, [pdfPreviewUrl]);

  // Cuando el PDF firmado esté listo
  React.useEffect(function() {
    if (pdfFirmadoUrl) {
      if (modalOpenRef.current) {
        // Usuario firmó desde dentro del modal → mostrar modal de éxito
        setMostrarExito(true);
      } else {
        // Firmó desde el panel → abrir vista firmada
        setModalUrl(pdfFirmadoUrl);
        setModalEsFirmado(true);
        setModalOpen(true);
      }
    }
  }, [pdfFirmadoUrl]);

  function descargarFirmado() {
    var a = document.createElement('a');
    a.href = pdfFirmadoUrl;
    a.download = 'DeclaracionJurada_Firmada.pdf';
    a.click();
  }

  function abrirFirmado() {
    setModalUrl(pdfFirmadoUrl);
    setModalEsFirmado(true);
    setModalOpen(true);
  }

  function cerrarExito() {
    setMostrarExito(false);
    setModalUrl(pdfFirmadoUrl);
    setModalEsFirmado(true);
    // modalOpen se mantiene abierto para mostrar el PDF firmado
  }

  var documentoFirmado = yaFirmado || !!pdfFirmadoUrl;
  var puedeFiremar = descargardocumento && haVisto && !firmando && !documentoFirmado;
  var puedeFirmarEnModal = descargardocumento && !firmando && !documentoFirmado && !modalEsFirmado;

  return (
    <>
      {/* Modal de éxito tras firmar */}
      {mostrarExito && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10001, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.7)' }}>
          <div style={{ background: '#fff', borderRadius: '20px', padding: '48px 40px', textAlign: 'center', maxWidth: '440px', width: '90%', boxShadow: '0 24px 64px rgba(0,0,0,0.4)' }}>
            <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'linear-gradient(135deg, #1B5E20, #43A047)', margin: '0 auto 22px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 24px rgba(46,125,50,0.4)' }}>
              <i className="fas fa-check" style={{ color: '#fff', fontSize: '2.2rem' }}></i>
            </div>
            <div style={{ fontWeight: '800', fontSize: '1.4rem', color: '#1B5E20', marginBottom: '14px' }}>
              ¡Declaracion firmada con exito!
            </div>
            <div style={{ color: '#555', fontSize: '0.97rem', lineHeight: '1.7', marginBottom: '30px' }}>
              Su declaracion jurada ha sido firmada digitalmente y guardada correctamente en el sistema.
            </div>
            <button
              onClick={cerrarExito}
              style={{ background: 'linear-gradient(135deg, #1B5E20, #43A047)', color: '#fff', border: 'none', borderRadius: '12px', padding: '14px 48px', fontSize: '1.05rem', fontWeight: '700', cursor: 'pointer', boxShadow: '0 4px 16px rgba(46,125,50,0.45)' }}
            >
              <i className="fas fa-check" style={{ marginRight: '8px' }}></i>Aceptar
            </button>
          </div>
        </div>
      )}

      {/* Modal pantalla completa */}
      {modalOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          {/* Barra superior — 3 columnas: título | centro (firmar) | acciones */}
          <div style={{ background: '#1a237e', padding: '10px 20px', display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', gap: '12px', flexShrink: 0, minHeight: '56px' }}>
            {/* Izquierda: título */}
            <span style={{ color: '#fff', fontWeight: '700', fontSize: '0.9rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              <i className="fas fa-file-pdf" style={{ marginRight: '8px', color: '#ef5350' }}></i>
              {modalEsFirmado ? 'Declaracion Jurada — Firmada Digitalmente' : 'Declaracion Jurada — Vista Previa'}
            </span>

            {/* Centro: botón firmar o indicador firmado */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {puedeFirmarEnModal && (
                <button
                  onClick={onFirmarDocumento}
                  disabled={firmando}
                  style={{ background: firmando ? 'rgba(255,255,255,0.15)' : 'linear-gradient(135deg, #2E7D32, #43A047)', color: '#fff', border: '2px solid rgba(255,255,255,0.3)', borderRadius: '10px', padding: '9px 26px', fontSize: '0.9rem', fontWeight: '700', cursor: firmando ? 'not-allowed' : 'pointer', boxShadow: firmando ? 'none' : '0 3px 12px rgba(46,125,50,0.5)', whiteSpace: 'nowrap' }}
                >
                  {firmando
                    ? <span><i className="fas fa-spinner fa-spin" style={{ marginRight: '7px' }}></i>Firmando, espere...</span>
                    : <span><i className="fas fa-pen-nib" style={{ marginRight: '7px' }}></i>Firmar Declaracion</span>
                  }
                </button>
              )}
              {documentoFirmado && (
                <span style={{ color: '#a5d6a7', fontWeight: '700', fontSize: '0.88rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <i className="fas fa-check-circle"></i>Firmada
                </span>
              )}
            </div>

            {/* Derecha: acciones secundarias */}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'flex-end' }}>
              {modalEsFirmado && (
                <button
                  onClick={descargarFirmado}
                  style={{ background: '#2E7D32', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 18px', fontSize: '0.85rem', fontWeight: '700', cursor: 'pointer' }}
                >
                  <i className="fas fa-download" style={{ marginRight: '6px' }}></i>Descargar PDF
                </button>
              )}
              <button
                onClick={function() { setModalOpen(false); }}
                style={{ background: '#c62828', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 18px', fontSize: '0.85rem', fontWeight: '700', cursor: 'pointer' }}
              >
                <i className="fas fa-times" style={{ marginRight: '6px' }}></i>Cerrar
              </button>
            </div>
          </div>

          {/* Visor PDF */}
          <iframe
            key={modalUrl}
            src={modalUrl + '#navpanes=0&toolbar=0&zoom=page-fit'}
            style={{ flex: 1, border: 'none', width: '100%', height: '100%', display: 'block', background: '#525659' }}
            title="Visor PDF"
          />
        </div>
      )}

      {/* Panel de acciones */}
      <div style={{ background: '#fff', borderRadius: '16px', padding: '28px 24px', marginBottom: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: '1px solid #eee' }}>

        {/* Select oculto para condición laboral */}
        <select style={{ display: 'none' }} ref={usuarioDatoRef} onChange={onCondicionChange}>
          {condicionesLaborales.map(function(c) {
            return <option key={c.trabajador} value={c.trabajador}>{c.nombre}</option>;
          })}
        </select>

        {/* Título del panel */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ width: '52px', height: '52px', borderRadius: '50%', background: 'linear-gradient(135deg, #1565C0, #1a237e)', margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(21,101,192,0.3)' }}>
            <i className="fas fa-pen-nib" style={{ color: '#fff', fontSize: '1.3rem' }}></i>
          </div>
          <div style={{ fontWeight: '700', fontSize: '1.05rem', color: '#1a237e' }}>Firme su Declaracion Jurada</div>
        </div>

        {/* Botón Ver Documento */}
        <MDBBtn
          disabled={!descargardocumento || documentoFirmado}
          color="info"
          onClick={onVerDocumento}
          style={{ borderRadius: '12px', fontSize: '1rem', margin: '0 0 12px 0', padding: '14px', width: '100%', boxShadow: (descargardocumento && !documentoFirmado) ? '0 3px 10px rgba(21,101,192,0.3)' : 'none', opacity: (descargardocumento && !documentoFirmado) ? 1 : 0.5 }}
        >
          <i className="fas fa-eye mr-2"></i>Ver mi Declaracion
        </MDBBtn>

        {/* Aviso: debe ver el documento antes de firmar */}
        {!haVisto && descargardocumento && !documentoFirmado && (
          <div style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '8px', padding: '10px 14px', marginBottom: '12px', fontSize: '0.8rem', color: '#795548' }}>
            <i className="fas fa-info-circle mr-2" style={{ color: '#F57C00' }}></i>
            Presione <strong>"Ver mi Declaracion"</strong> para revisar su documento. Podra firmarlo desde esa misma vista.
          </div>
        )}

        {/* Botón Firmar en panel — solo visible si no está firmado */}
        {!documentoFirmado && (
          <MDBBtn
            disabled={!puedeFiremar}
            color="success"
            onClick={onFirmarDocumento}
            style={{ borderRadius: '12px', fontSize: '1rem', margin: 0, padding: '14px', width: '100%', boxShadow: puedeFiremar ? '0 3px 10px rgba(46,125,50,0.3)' : 'none', opacity: puedeFiremar ? 1 : 0.5 }}
          >
            {firmando
              ? <span><i className="fas fa-spinner fa-spin mr-2"></i>Aplicando firma digital, por favor espere...</span>
              : <span><i className="fas fa-pen-nib mr-2"></i>Firmar Digitalmente</span>
            }
          </MDBBtn>
        )}

        {/* Error de firma */}
        {errorFirma && (
          <div style={{ background: '#ffebee', border: '1px solid #ef9a9a', borderRadius: '10px', padding: '12px 16px', marginTop: '16px', color: '#c62828', fontSize: '0.83rem' }}>
            <i className="fas fa-exclamation-triangle mr-2"></i>{errorFirma}
          </div>
        )}

        {/* Documento firmado — banner prominente */}
        {documentoFirmado && (
          <div style={{ background: 'linear-gradient(135deg, #1B5E20, #2E7D32)', borderRadius: '16px', padding: '28px 20px', marginTop: '4px', textAlign: 'center', boxShadow: '0 8px 28px rgba(46,125,50,0.4)' }}>
            <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(255,255,255,0.18)', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i className="fas fa-check-circle" style={{ color: '#fff', fontSize: '2rem' }}></i>
            </div>
            <div style={{ fontWeight: '800', color: '#fff', fontSize: '1.15rem', marginBottom: '8px' }}>
              Declaracion Jurada Firmada
            </div>
            <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.9rem', marginBottom: pdfFirmadoUrl ? '20px' : '0', lineHeight: '1.6' }}>
              Su declaracion ha sido presentada y firmada digitalmente con exito.
            </div>
            {pdfFirmadoUrl && (
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
                <button
                  onClick={abrirFirmado}
                  style={{ background: 'rgba(255,255,255,0.18)', color: '#fff', border: '2px solid rgba(255,255,255,0.55)', borderRadius: '10px', padding: '10px 22px', fontSize: '0.87rem', fontWeight: '700', cursor: 'pointer' }}
                >
                  <i className="fas fa-eye" style={{ marginRight: '6px' }}></i>Ver documento firmado
                </button>
                <button
                  onClick={descargarFirmado}
                  style={{ background: '#fff', color: '#2E7D32', border: 'none', borderRadius: '10px', padding: '10px 22px', fontSize: '0.87rem', fontWeight: '700', cursor: 'pointer' }}
                >
                  <i className="fas fa-download" style={{ marginRight: '6px' }}></i>Descargar PDF firmado
                </button>
              </div>
            )}
          </div>
        )}

        {/* Estado de la declaracion */}
        {hasRegistros && (
          <div style={{ background: 'linear-gradient(135deg, #e3f2fd, #e8eaf6)', border: '1px solid #bbdefb', borderRadius: '10px', padding: '14px 18px', marginTop: '16px' }}>
            <div style={{ fontWeight: '700', color: '#1565C0', marginBottom: '8px', fontSize: '0.82rem' }}>
              <i className="fas fa-clipboard-check mr-2"></i>Estado de su declaracion:
            </div>
            {informacionregistro.map(function(r) {
              return (
                <div key={r.trabajador} style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', fontSize: '0.83rem' }}>
                  <span style={{ color: '#333' }}><strong>Documento:</strong> {r.documento}</span>
                  <span style={{ background: '#1565C0', color: '#fff', borderRadius: '12px', padding: '3px 10px', fontSize: '0.72rem', fontWeight: '600' }}>{r.fechasubida}</span>
                  <span style={{ background: '#F57C00', color: '#fff', borderRadius: '12px', padding: '3px 10px', fontSize: '0.72rem', fontWeight: '600' }}>{r.estado}</span>
                </div>
              );
            })}
          </div>
        )}

      </div>
    </>
  );
}

export default PanelFirmaDigital;
